export function downloadFile(url: string, fileName?: string) {
  if (!url) {
    console.log('Url not specified to download');
    return;
  }

  const a = document.createElement('A') as HTMLAnchorElement;
  a.href = url;
  a.target = '_blank'; //adding the target attribute to prevent beforeunload event trigger in IE as IE doen not support download tag on anchor
  a.download = fileName || url.substr(url.lastIndexOf('/') + 1);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
